PrefacturationValidator.$inject = ['validator'];

export default function PrefacturationValidator(validator) {
    const instance = new validator();
    return instance;
}
